var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":_vm.disabled,"size":_vm.size,"icon-right":_vm.showIcon ? "download" : ""},on:{"click":_vm.download}},[(!_vm.hideLabel)?_c('span',[_vm._v("Exportar a Excel")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }